export function main() {
  
  $(window).on('load', function() {
  	if(location.hash)
    	$('html, body').animate({scrollTop: $(location.hash).offset().top - 120}, 'linear')
 	});
  
  $('a[href*="#"]:not([href="#"])').click(function(e) {
    e.preventDefault();
    var _url_page = $(this)[0].href.split('#')[0];
    if( window.location.href === _url_page ){
      
      var mobile_menu_open = $("#mobile-menu").hasClass("open");
      var menu_item_active = $('.site-nav .menu-item-type-custom').hasClass('active');

      $('html, body').stop().animate({scrollTop: $(this.hash).offset().top - 120}, 'linear');    
      if(mobile_menu_open){
        $('#mobile-menu').trigger('click');
      }  
      if(menu_item_active){
        setTimeout(function(){
          $('.site-nav .menu-item-type-custom').removeClass('active');
        }, 1000);      
      }   
    } else {
      window.location.href = $(this)[0].href;
    }
  });

  $('#mobile-menu').click(function() {

    $('html,body').toggleClass("noscroll");

    $('.overlay-content .menu-item-type-custom').removeClass('active');

    if($(this).hasClass("open")) {
      $("#mobileNav").height("0");
    }
    else {
      $("#mobileNav").height("100%");
    }

    $("#mobileNav").css("margin-top", 70);
    $("#mobileNav .overlay-content").css("margin-bottom", 70);

    $(this).toggleClass("open");

  });
  
  $('.overlay-content .menu-item-type-custom > a').click(function(e) {
    e.preventDefault();
    
    var isActive = $(this).parent().hasClass('active');
    
    $('.overlay-content .menu-item-type-custom').removeClass('active');
    
    if(!isActive){
      if($('img[data-menu-src]').length > 0){
        $('img[data-menu-src]').each(function () {
          var _data_src = $(this).attr('data-menu-src');
          $(this).attr('src', _data_src).removeAttr('data-menu-src');
        });
      }
      $(this).parent().addClass('active');
    }     
  });

  $('.overlay-content').click(function(e) {
    if(!$(e.target).is('.site-mobile-nav *'))
      $('.menu-item-type-custom').removeClass('active');
  });

  $('.site-nav .menu-item-type-custom').hover(
    function () {
      $(this).addClass('active');/*
      if($('img[data-menu-src]').length > 0){
        $('img[data-menu-src]').each(function () {
          var _data_src = $(this).attr('data-menu-src');
          $(this).attr('src', _data_src).removeAttr('data-menu-src');
        });
      }*/
    }, 
    function () {
      $(this).removeClass('active');
    }
  );
  
  $('#blog-year-select, #blog-tag-select').change(function(e) {
    
    e.preventDefault();
    
    window.location.href = window.location.href.split('?')[0] + '?' + $.param({ b_year: $('#blog-year-select option:selected').val(), b_cat: $('#blog-tag-select option:selected').val() });
    
  });
  
  $('#blog-year-select-videos').change(function(e) {
    
    e.preventDefault();
    
    window.location.href = location.protocol + '//' + location.host + location.pathname + '?' + $.param({ b_year_videos: $('#blog-year-select-videos option:selected').val(), b_year_photos: $('#blog-year-select-photos option:selected').val(), b_cat_videos: $('.blog-nav-inner.video-cat a.active').data('val'), b_cat_photos: $('.blog-nav-inner.photo-cat a.active').data('val') }) + '#videos-archive';
    
  });
  
  $('#blog-year-select-photos').change(function(e) {
    
    e.preventDefault();
    
    window.location.href = location.protocol + '//' + location.host + location.pathname + '?' + $.param({ b_year_videos: $('#blog-year-select-videos option:selected').val(), b_year_photos: $('#blog-year-select-photos option:selected').val(), b_cat_videos: $('.blog-nav-inner.video-cat a.active').data('val'), b_cat_photos: $('.blog-nav-inner.photo-cat a.active').data('val') }) + '#photos-archive';
    
  });
  
  $('.blog-nav-inner.video-cat a').click(function(e) {
    
    e.preventDefault();
    
    window.location.href = location.protocol + '//' + location.host + location.pathname + '?' + $.param({ b_year_videos: $('#blog-year-select-videos option:selected').val(), b_year_photos: $('#blog-year-select-photos option:selected').val(), b_cat_videos: $(this).data('val'), b_cat_photos: $('.blog-nav-inner.photo-cat a.active').data('val') }) + '#videos-archive';
  
  });
  
  $('.blog-nav-inner.photo-cat a').click(function(e) {
    
    e.preventDefault();
    
    window.location.href = location.protocol + '//' + location.host + location.pathname + '?' + $.param({ b_year_videos: $('#blog-year-select-videos option:selected').val(), b_year_photos: $('#blog-year-select-photos option:selected').val(), b_cat_videos: $('.blog-nav-inner.video-cat a.active').data('val'), b_cat_photos: $(this).data('val') }) + '#photos-archive';
  
  });
  
  $('.page-template-page-videos-photos #videos .wp-pagenavi a.page').click(function(e) {
  
    e.preventDefault();
    
    window.location.href = location.protocol + '//' + location.host + location.pathname + '?' + $.param({ paged_videos: $(this).text(), paged_photos: parseInt($('.page-template-page-videos-photos #photos .wp-pagenavi .current').text()), b_year_videos: $('#blog-year-select-videos option:selected').val(), b_year_photos: $('#blog-year-select-photos option:selected').val(), b_cat_videos: $('.blog-nav-inner.video-cat a.active').data('val'), b_cat_photos: $('.blog-nav-inner.photo-cat a.active').data('val') }) + '#videos-archive';
  
  });
  
  $('.page-template-page-videos-photos #photos .wp-pagenavi a.page').click(function(e) {
  
    e.preventDefault();
    
    window.location.href = location.protocol + '//' + location.host + location.pathname + '?' + $.param({ paged_videos: parseInt($('.page-template-page-videos-photos #videos .wp-pagenavi .current').text()), paged_photos: $(this).text(), b_year_videos: $('#blog-year-select-videos option:selected').val(), b_year_photos: $('#blog-year-select-photos option:selected').val(), b_cat_videos: $('.blog-nav-inner.video-cat a.active').data('val'), b_cat_photos: $('.blog-nav-inner.photo-cat a.active').data('val') }) + '#photos-archive';
  
  });
  
  $('.page-template-page-videos-photos #videos .wp-pagenavi a.nextpostslink').click(function(e) {
  
    e.preventDefault();
    
    window.location.href = location.protocol + '//' + location.host + location.pathname + '?' + $.param({ paged_videos: parseInt($('.page-template-page-videos-photos #videos .wp-pagenavi .current').text()) + 1, paged_photos: parseInt($('.page-template-page-videos-photos #photos .wp-pagenavi .current').text()), b_year_videos: $('#blog-year-select-videos option:selected').val(), b_year_photos: $('#blog-year-select-photos option:selected').val(), b_cat_videos: $('.blog-nav-inner.video-cat a.active').data('val'), b_cat_photos: $('.blog-nav-inner.photo-cat a.active').data('val') }) + '#videos-archive';
  
  });
  
  $('.page-template-page-videos-photos #photos .wp-pagenavi a.nextpostslink').click(function(e) {
  
    e.preventDefault();
    
    window.location.href = location.protocol + '//' + location.host + location.pathname + '?' + $.param({ paged_videos: parseInt($('.page-template-page-videos-photos #videos .wp-pagenavi .current').text()), paged_photos: parseInt($('.page-template-page-videos-photos #photos .wp-pagenavi .current').text()) + 1, b_year_videos: $('#blog-year-select-videos option:selected').val(), b_year_photos: $('#blog-year-select-photos option:selected').val(), b_cat_videos: $('.blog-nav-inner.video-cat a.active').data('val'), b_cat_photos: $('.blog-nav-inner.photo-cat a.active').data('val') }) + '#photos-archive';
  
  });
  
  $('.page-template-page-videos-photos #videos .wp-pagenavi a.previouspostslink').click(function(e) {
  
    e.preventDefault();
    
    window.location.href = location.protocol + '//' + location.host + location.pathname + '?' + $.param({ paged_videos: parseInt($('.page-template-page-videos-photos #videos .wp-pagenavi .current').text()) - 1, paged_photos: parseInt($('.page-template-page-videos-photos #photos .wp-pagenavi .current').text()), b_year_videos: $('#blog-year-select-videos option:selected').val(), b_year_photos: $('#blog-year-select-photos option:selected').val(), b_cat_videos: $('.blog-nav-inner.video-cat a.active').data('val'), b_cat_photos: $('.blog-nav-inner.photo-cat a.active').data('val') }) + '#videos-archive';
  
  });
  
  $('.page-template-page-videos-photos #photos .wp-pagenavi a.previouspostslink').click(function(e) {
  
    e.preventDefault();

    window.location.href = location.protocol + '//' + location.host + location.pathname + '?' + $.param({ paged_videos: parseInt($('.page-template-page-videos-photos #videos .wp-pagenavi .current').text()), paged_photos: parseInt($('.page-template-page-videos-photos #photos .wp-pagenavi .current').text()) - 1, b_year_videos: $('#blog-year-select-videos option:selected').val(), b_year_photos: $('#blog-year-select-photos option:selected').val(), b_cat_videos: $('.blog-nav-inner.video-cat a.active').data('val'), b_cat_photos: $('.blog-nav-inner.photo-cat a.active').data('val') }) + '#photos-archive';
  
  });
  /*
  $('video').bind('play', function (e) {

    $.ajax({
      method: "POST",
      dataType: 'json',
      url: ajax_params.ajaxurl,
      data: {
        action: "video_increment_count",
        post_id: $(this).closest('.video-wrapper').data('postid'),
      },
    });
    
  });
  */
}


// WEBPACK FOOTER //
// ./assets/js/modules/main.js